<template>
  <ModalContainer
    :showModal="true"
    :title="title"
    @closeModal="closeModal"
  >
    <p class="mt-4">{{ text }}</p>
    <div class="mt-6 flex justify-center gap-2">
      <Button @click="clicked_no" button_text="No" button_id="confirm_no"/>
      <Button @click="clicked_yes" button_text="Yes" button_id="confirm_yes"/>
    </div>
  </ModalContainer>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import Button from "@/components/buttons/Button.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";

export default {
  name: "AlertConfirmation",
  components: {
    Card,
    Button,
    ModalContainer,
  },
  data() {
    return {
      yes: false,
      no: false,
    };
  },
  props: {
    text: String,
    text_class: String,
    animation_class: String,
    title: String
  },
  methods: {
    clicked_yes() {
      setTimeout(() => {
        this.$emit("confirmYes");
      }, 100);
    },
    clicked_no() {
      setTimeout(() => {
        this.$emit("confirmNo");
      }, 100);
    },
    closeModal() {
      setTimeout(() => {
        this.$emit("confirmNo");
      }, 100);
    },
  },
};
</script>
